module.exports = __webpack_public_path__ + "static/img/rug_01.d1da3ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rug_01.png
// module id = ElXI
// module chunks = 17